import Skeleton from "react-loading-skeleton";

/**
 * Skeleton placeholder for the TabsList component.
 * Matches the glassmorphism pill-style container of the real Tabs component.
 */
export function TabBarSkeleton({ tabWidths }: { tabWidths: number[] }) {
	return (
		<div className="flex w-fit gap-1 p-1 rounded-xl bg-base-200/50 ring-1 ring-base-content/5">
			{tabWidths.map((w, i) => (
				<Skeleton key={i} width={w} height={28} borderRadius={8} />
			))}
		</div>
	);
}
